<!--  -->
<template>
    <div class="recommend_box">
        <div class="recommend" v-if="!loading">
            <!-- <div class="left">
                <div class="line"></div>
            </div> -->
            <div class="right">
                <div class="title">
                    <img :src="require('@/common/images/special/rmtj.png')" alt="">
                    热门推荐
                    <!-- <div class="circle" ></div> -->
                </div>
                <div class="item" v-for="(item, index) in list" :key="index">
                    <div class="circle"></div>
                    <p class="name" @click="openLink(item)">{{item.subject}}</p>
                </div>
            </div>
        </div>
        <div class="placeholder_box" v-else>
            <div class="title">热门推荐</div>
            <skeleton type='listcom' v-if="loading" active :options="{row: 7, lineHight: 40}" />
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
    data() {
        return {

        }
    },
    props: ['list', 'loading'],
    // 生命周期 - 创建完成（访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {
        openLink(item) {
            if (item.urltype === 2) {
                window.open(item.linkurl)
            } else {
                window.open(`${location.origin}/messageDetails?contentid=${item.contentid}&token=${this.user.loginToken}`)
            }
        }
    },
    computed: {
        ...mapGetters(['user'])
    }
}
</script>
<style scoped lang='scss'>
/* @import url(); 引入css类 */
    .recommend_box {
        max-height: 390px;
        .recommend {
            display: flex;
            .left {
                margin-right: 14px;
                padding-left: 4px;
                position: relative;
                top: 10px;
                .line {
                    max-height: 372px;
                    height: 100%;
                    width: 2px;
                    background: #E5E5E5;
                }
            }
            .right {
                .title {
                    width: 260px;
                    font-weight: bold;
                    font-size: 18px;
                    line-height: 25px;
                    position: relative;
                    margin-bottom: 12px;
                    display: flex;
                    align-items: center;
                    border-bottom: 1px solid #E5E5E5;
                    padding-bottom: 10px;
                    img {
                        width: 16px;
                        height: 16px;
                        margin-right: 5px;
                    }
                    .circle {
                        width: 10px;
                        height: 10px;
                        border-radius: 50%;
                        background: linear-gradient(180deg, #74CDFF 0%, #409EFF 100%);
                        position: absolute;
                        top: 8px;
                        left: -20px;
                    }
                }
                .item {
                    position: relative;
                    display: flex;
                    align-items: center;
                    height: 20px;
                    padding-bottom: 1.5px;
                    // box-sizing: border-box;
                    .name {
                        // height: 40px;
                        width: 245px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        // display: -webkit-box;
                        // -webkit-line-clamp: 2;
                        // line-clamp: 2;
                        // -webkit-box-orient: vertical;
                        font-size: 14px;
                        line-height: 20px;
                        cursor: pointer;
                        &:hover {
                            color: #409EFF;
                        }
                    }
                    &:not(:last-of-type) {
                        margin-bottom: 12px;
                    }
                    .circle {
                        // position: absolute;
                        // top: 14px;
                        // left: -20px;
                        width: 10px;
                        height: 10px;
                        border-radius: 50%;
                        border: 1px solid #409EFF;
                        box-sizing: border-box;
                        background: #fff;
                        margin-right: 5px;
                    }
                }
            }
            .contianer_S8Y9lJLI {
                width: 100%;
            }
        }
        .placeholder_box {
            .title {
                font-size: 18px;
                font-weight: bold;
                padding-left: 12px;
            }
        }
    }
</style>